import * as React from "react"
import AppBar from "@mui/material/AppBar"
import Box from "@mui/material/Box"
import Toolbar from "@mui/material/Toolbar"
import IconButton from "@mui/material/IconButton"
import Typography from "@mui/material/Typography"
import PropTypes from "prop-types"
import { PersonOutline } from "@material-ui/icons"
import UserProfileMenu from "./UserProfileMenu"
import EYLogo from "./../images/EYLogo"
// @ts-ignore
import { useHistory } from "react-router-dom"

export default function Header({
  title,
  user,
  accountName,
  children,
  additionalUserProfileMenuItems,
  handleSignIn,
  handleSignOut,
  handleMyReviewsClick,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const history = useHistory()

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleLogoClick = () => {
    history.push("/v2/landing")
  }

  const menuId = "primary-search-account-menu"

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        sx={{
          zIndex: (theme) => 99,
          padding: "0 !important",
        }}
        position="fixed"
      >
        <Toolbar>
          <Typography 
            variant="h6" 
            noWrap 
            component="div" 
            sx={{ 
              display: 'flex', 
              alignItems: 'center',
              fontSize: {
                xs: '0.85rem',
                sm: '1rem', 
                md: '1.25rem'
              }
            }}
          >
            <Box
              sx={{
                cursor: "pointer", 
                marginRight: { xs: "12px", md: "20px" }, 
                display: 'flex', 
                alignItems: 'center'
              }}
              onClick={handleLogoClick}
            >
              <Box
                sx={{
                  width: { xs: '80px', md: '120px' }
                }}
              >
                <EYLogo width="100%" />
              </Box>
            </Box>
            {title}
          </Typography>
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: "flex" }}>
            {handleMyReviewsClick && (
              <Box
                sx={{
                  display: { xs: "none", md: "block" },
                  margin: "auto",
                  paddingRight: "24px",
                  opacity: 0.6,
                  cursor: "pointer",
                  "&:hover": {
                    opacity: 1,
                    "& .MuiTypography-root": {
                      color: "#fff",
                    },
                  },
                }}
                id={"v2-my-reviews-button"}
                onClick={handleMyReviewsClick}
              >
                <Typography variant="body2" noWrap>
                  My Reviews
                </Typography>
              </Box>
            )}
            {accountName && (
              <Box
                sx={{
                  display: { xs: "none", md: "block" },
                  margin: "auto",
                  paddingRight: "24px",
                  opacity: 0.6,
                }}
              >
                <Typography variant="body2">Account</Typography>
                <Typography variant="body2" noWrap>
                  {accountName==' (undefined)' ? null : accountName}
                </Typography>
              </Box>
            )}
            <IconButton
              size="large"
              sx={{ top: "3px" }}
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <PersonOutline />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      <UserProfileMenu
        anchorEl={anchorEl}
        handleMenuClose={handleMenuClose}
        accountName={accountName}
        user={user}
        handleSignIn={handleSignIn}
        handleSignOut={handleSignOut}
        menuId={menuId}
        additionalUserProfileMenuItems={additionalUserProfileMenuItems}
      />
      <Box component="main">
        <Toolbar />
        {children}
      </Box>
    </Box>
  )
}

Header.propTypes = {
  user: PropTypes.shape({
    given_name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    picture: PropTypes.string,
  }).isRequired,
  title: PropTypes.string.isRequired,
  accountName: PropTypes.string,
  handleSignIn: PropTypes.func.isRequired,
  handleSignOut: PropTypes.func.isRequired,
  handleMyReviewsClick: PropTypes.func,
  children: PropTypes.any,
}
